import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import TestFit from "@/pages/TestFit";
import Leadership from "@/pages/Leadership";
import Curriculum from "@/pages/Curriculum";
import About from "@/pages/About";
import Speaking from "@/pages/Speaking";
import BeyondTheScore from "@/pages/BeyondTheScore";
import GLA from "@/pages/GLA";
import Contact from "@/pages/Contact";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Toaster position="top-right" richColors />
                <Routes>
                    <Route element={<Layout />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/testfit" element={<TestFit />} />
                        <Route path="/leadership" element={<Leadership />} />
                        <Route path="/gla" element={<GLA />} />
                        <Route path="/glad-score" element={<GLA />} />
                        <Route path="/curriculum" element={<Curriculum />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/speaking" element={<Speaking />} />
                        <Route path="/beyond-the-score" element={<BeyondTheScore />} />
                        <Route path="/insights" element={<BeyondTheScore />} />
                        <Route path="/contact" element={<Contact />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
